import React from 'react';
import './Footer.css';

const InstagramIcon = () => (
  <svg viewBox="0 0 24 24" aria-hidden="true" className="social-icon">
    <rect x="3" y="3" width="18" height="18" rx="5" ry="5" fill="none" stroke="currentColor" strokeWidth="2" />
    <circle cx="12" cy="12" r="4" fill="none" stroke="currentColor" strokeWidth="2" />
    <circle cx="17.5" cy="6.5" r="1.2" fill="currentColor" />
  </svg>
);

const WhatsAppIcon = () => (
  <svg viewBox="0 0 24 24" aria-hidden="true" className="social-icon">
    <path
      d="M20 12a8 8 0 0 1-11.7 7.1L4 20l.9-4.1A8 8 0 1 1 20 12Z"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinejoin="round"
    />
    <path
      d="M9.6 8.9c.2-.4.4-.4.6-.4h.5c.1 0 .3 0 .4.3l.9 2c.1.2.1.4 0 .5l-.4.5c-.1.1-.2.3-.1.5.3.6.8 1.1 1.3 1.5.5.4 1.1.7 1.7 1 .2.1.4 0 .5-.1l.5-.6c.1-.1.3-.2.5-.1l1.8.8c.2.1.3.2.3.4v.5c0 .2-.1.4-.4.6-.4.2-1 .4-1.6.3-1 0-2.3-.5-3.8-1.8-1.9-1.6-2.8-3.5-2.9-4.6-.1-.6.1-1.2.3-1.5Z"
      fill="currentColor"
    />
  </svg>
);

const Footer = () => {
  const instagramUrl = 'https://www.instagram.com/the_bluepoint_org_kakkanad?igsh=em04YTFxZGw3OTc=';
  const whatsappUrl = 'https://wa.me/919447750005';

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-section">
          <h3>The Bluepoint Org</h3>
          <p>
            A mission-driven organisation working to build healthy, safe, and thriving communities through
            Health, Education, Child Protection, and Sustainable Development.
          </p>
        </div>

        <div className="footer-section">
          <h3>Quick Links</h3>
          <ul>
            <li><a href="/about">About Us</a></li>
            <li><a href="/youth-training">Youth Training</a></li>
            <li><a href="/hr-development">HR Development</a></li>
            <li><a href="/gallery">Gallery</a></li>
            <li><a href="/contact">Contact Us</a></li>
          </ul>
        </div>

        <div className="footer-section">
          <h3>Focus Areas</h3>
          <ul>
            <li>Health</li>
            <li>Education</li>
            <li>Child Protection</li>
            <li>Sustainable Development</li>
          </ul>
        </div>

        <div className="footer-section footer-contact-section">
          <h3>Contact Info</h3>
          <div className="contact-address-grid">
            <div className="contact-card">
              <p><strong>Thiruvananthapuram Office:</strong><br />
                B - 36, Althara Nagar, Vellayambalam<br />
                Sasthamangalam PO, Thiruvananthapuram<br />
                Kerala - 695 010
              </p>
            </div>
            <div className="contact-card">
              <p><strong>Kakkanad Office:</strong><br />
                The Bluepoint Org<br />
                2nd floor, Chitranjali studio building<br />
                Near NGO quarters, Ambadimoola, Kakkanad<br />
                Pin: 682021
              </p>
            </div>
          </div>
          <div className="contact-meta-grid">
            <div className="contact-card">
              <p><strong>Phone:</strong><br />
                0471-7964498<br />
                +91-9447750005<br />
                +91-8589885753
              </p>
            </div>
            <div className="contact-card">
              <p><strong>Email:</strong><br />
                bluepointkerala@gmail.com
              </p>
            </div>
          </div>
        </div>

        <div className="footer-section footer-social-section">
          <h3>Social Media</h3>
          <ul className="social-links">
            <li>
              <a href={instagramUrl} target="_blank" rel="noreferrer" className="social-link-item">
                <InstagramIcon />
                <span>Instagram</span>
              </a>
            </li>
            <li>
              <a href={whatsappUrl} target="_blank" rel="noreferrer" className="social-link-item">
                <WhatsAppIcon />
                <span>WhatsApp: +91-9447750005</span>
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div className="footer-bottom">
        <p>&copy; {new Date().getFullYear()} The Bluepoint Org. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;
